module.exports = "/images/v3_logo_dark.svg?9113b51e4bd9d932d091e5fc275b2fea";